import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistActiveItemsReducer } from 'features/Persist/reducerTypes';
import { TenantIsActiveResponse } from 'services/tenantManagementService';
import { SUPPORT_ORGANIZATIONS_SET, SUPPORT_ORGANIZATIONS_FETCHING } from './action';

export const supportOrganizationsReducer = (state = new PersistActiveItemsReducer<TenantIsActiveResponse>(), action: PersistItemsActionType<TenantIsActiveResponse> | FetchingActionType): PersistActiveItemsReducer<TenantIsActiveResponse> => {
	switch (action.type) {
		case SUPPORT_ORGANIZATIONS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case SUPPORT_ORGANIZATIONS_SET:
			const { items } = action as PersistItemsActionType<TenantIsActiveResponse>;

			const itemsMap: { [id: number]: TenantIsActiveResponse } = items.reduce(
				(map: { [id: number]: TenantIsActiveResponse }, item) => {
					map[item.id] = item;
					return map;
				},
				{}
			);

			const activeItems = items.filter(x => x.isActive);

			const activeItemsMap: { [id: number]: TenantIsActiveResponse } = items.reduce(
				(map: { [id: number]: TenantIsActiveResponse }, item) => {
					if (item.isActive) {
						map[item.id] = item;
					}
					return map;
				},
				{}
			);

			return {
				items,
				itemsMap,
				activeItems,
				activeItemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
}